import ApiService from '../apiservice'

export default class TarefaService extends ApiService {
  constructor() {
    super('/tarefa');
  }

  cadastrar(tarefa) {
    return this.post('/',tarefa);
  }

  listar(empresa) {
    return this.get(`/${empresa}`);
  }

  consultar(codigo) {
    return this.get(`/porCodigo/${codigo}`);
  }

  alterar(tarefa) {
    return this.put('/',tarefa);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }

  listarUsuariosNaoCadastrados(tarefa, empresa) {
    return this.get(`/usuariosNaoCadastrados?tarefa=${tarefa}&empresa=${empresa}`);
  }

  adicionarTarefaGrupo(agrupa) {
    return this.post('/adicionarTarefaGrupo',agrupa);
  }

  listarGruposPorTarefa(tarefa) {
    return this.get(`/gruposPorTarefa/${tarefa}`);
  }

  listarGruposSemTarefa(tarefa,empresa) {
    const params = `/gruposSemTarefa?tarefa=${tarefa}&empresa=${empresa}`;
    return this.get(`/gruposSemTarefa?tarefa=${tarefa}&empresa=${empresa}`);
  }
  
  excluirAgrupamento(tarefa, grupo) {
    return this.delete(`/excluirAgrupamento?tarefa=${tarefa}&grupo=${grupo}`);
  }

  listarTarefasSemGrupo(grupo,empresa) {
    return this.get(`/tarefasSemGrupo?grupo=${grupo}&empresa=${empresa}`);
  }

  consultarAgrupamento(tarefa,grupo) {
    return this.get(`/consultarAgrupamento?tarefa=${tarefa}&grupo=${grupo}`);
  }

  adicionarUsuarioTarefa(usuarioTarefa) {
    return this.post('/adicionarUsuarioTarefa',usuarioTarefa);
  }

  listarUsuariosPorTarefa(tarefa) {
    return this.get(`/usuariosPorTarefa/${tarefa}`);
  }

  excluirUsuarioTarefa(codigo) {
    return this.delete(`/excluirUsuario/${codigo}`);
  }

  listarTarefasPorGrupo(grupo) {
    return this.get(`/tarefasPorGrupo/${grupo}`);
  }
}